/**
 * Keep CSS vars in sync with the real visible viewport (FABs, drawers, sheets).
 * One tracker — sheets, the owner dock and keyboard compensation all read it.
 */
import { startStoreVisualViewport } from '~/utils/storeVisualViewport'

export default defineNuxtPlugin(() => {
  const route = useRoute()

  const start = () => {
    startStoreVisualViewport()
  }

  const authed = document.cookie.includes('kawaderna_token=')
  if (route.path.startsWith('/store') && !authed) {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 4000 })
    else window.setTimeout(start, 1)
    return
  }

  start()
})
